import React, { useState } from "react";
import { ArrowRight, Loader2 } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { useToast } from "../hooks/use-toast";
import { joinWaitlist } from "../lib/api";

const CTA = () => {
  const { toast } = useToast();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const join = async () => {
    const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (!valid) {
      toast({ title: "Enter a valid email", description: "We need a real address to reach you." });
      return;
    }
    setBusy(true);
    try {
      const res = await joinWaitlist(email);
      toast({
        title: res.status === "already_joined" ? "You're already on the list!" : "You're on the list!",
        description: "We'll email you when new AI build tools launch.",
      });
      setEmail("");
    } catch (e) {
      toast({ title: "Something went wrong", description: "Please try again in a moment." });
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="py-24 bg-slate-50">
      <div className="max-w-5xl mx-auto px-5 sm:px-8">
        <div className="relative overflow-hidden rounded-3xl bg-[#0A2540] px-8 py-16 sm:px-16 text-center">
          <div className="absolute -top-16 -right-16 h-56 w-56 rounded-full bg-[#DC2626]/20 blur-3xl" />
          <div className="absolute -bottom-16 -left-16 h-56 w-56 rounded-full bg-[#1D4ED8]/30 blur-3xl" />
          <div className="relative">
            <h2 className="font-display text-4xl sm:text-5xl font-700 text-white leading-tight">
              Your next build starts with a number.
            </h2>
            <p className="mt-5 text-lg text-slate-300 max-w-2xl mx-auto">
              Create your free profile and get an instant, contractor-grade estimate on your first design.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
              <Button
                onClick={() => scrollTo("#estimator")}
                className="h-12 px-7 text-base bg-[#DC2626] hover:bg-[#b91c1c] text-white group"
              >
                Create free profile
                <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
              </Button>
            </div>

            <div className="mt-6 flex flex-col sm:flex-row gap-2 justify-center max-w-md mx-auto">
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && join()}
                placeholder="you@email.com"
                className="h-12 bg-white/10 border-white/20 text-white placeholder:text-slate-400 focus-visible:ring-white/40"
              />
              <Button
                onClick={join}
                disabled={busy}
                variant="outline"
                className="h-12 px-6 text-base border-white/30 bg-transparent text-white hover:bg-white/10 shrink-0"
              >
                {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Join the waitlist"}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
